<template>
  <div class="simple-card" style="background-color: #F8F8F8">
    <div class="info-card-content">
      <h3 class="simple-card-title" style="margin: 0">{{$t('pages.ratingHistory.ratingHistory')}}</h3>
      <div id="leaderboard" style="max-height: 315px; overflow-y: auto">
        <table>
          <tbody>
          <tr>
            <th>{{$t('pages.ratingHistory.date')}}</th>
            <th colspan="2">{{$t('pages.ratingHistory.numberOfPoints')}}</th>

            <th>{{$t('pages.ratingHistory.rating')}}</th>
          </tr>
          <tr v-for="(izpit, i) in ratingHistory.slice().reverse()" class="history-cell" @click="showResultsForOneExam(izpit.examAttemptId)">
            <td>{{new Date(izpit.date).toLocaleString('default', { day: 'numeric', month: 'short' })}}</td>
            <td>
              <div class="progress-container">
                <div v-if="izpit.points/izpit.maxPoints >= 0.75" class="progress" :style="'background-color: #00a65a; width:' + (100 * izpit.points / izpit.maxPoints) + '%'"></div>
                <div v-else-if="izpit.points/izpit.maxPoints >= 0.25" class="progress" :style="'background-color: #f39c12; width:' + (100 * izpit.points / izpit.maxPoints) + '%'"></div>
                <div v-else class="progress" :style="'background-color: #dd4b39; width:' + (100 * izpit.points / izpit.maxPoints) + '%'"></div>
              </div>
            </td>
            <td>
              <span class="badge bg-blue">{{izpit.points.toFixed(1) + '/' + izpit.maxPoints}}</span>
            </td>
            <td style="text-align: center; font-weight: bold">{{izpit.newRating}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import router from '@/router/router'
import Rest from '@/services/rest'

export default {
  name: 'rating-history-card',
  props: ['gid', 'uid'],
  data () {
    return {
      ratingHistory: []
    }
  },
  created () {
    this.pridobiPodatke()
  },
  methods: {
    showResultsForOneExam (attemptId) {
      if (this.dataById) {
        router.push({name: 'classExamResultsAdmin', params: {classExamId: attemptId}})
      } else {
        router.push({name: 'ratingResults', params: {sid: 'root', attemptId: attemptId}})
      }
    },
    pridobiPodatke () {
      let postdata = {
        groupId: this.gid
      }
      if (this.dataById) {
        postdata['userId'] = this.uid
      }
      return Rest.request('POST', `/rating/userRatingStatistics`, postdata).then((data) => {
        this.ratingHistory = data.history
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../../assets/k6styles/cards';

#leaderboard {
  margin-top: 30px;
  width: 100%;
  position: relative;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  color: #141a39;
  cursor: default;
}
th {
  padding: 15px !important;
  font-size: 15px;
  border-bottom: 1px solid #efefef;
}
tr {
  transition: all 0.2s ease-in-out;
  border-radius: 0.2rem;
}

tr:nth-child(odd) {
  background-color: #F8F8F8;
}

tr:nth-child(1) {
  color: rgb(58, 58, 58);
}

td {
  height: 5.2rem;
  font-family: "Rubik", sans-serif;
  font-size: 1.3rem;
  padding: 1rem 2rem;
  position: relative;
  border-bottom: 1px solid #efefef;
}
.history-cell:hover {
  background-color: #efefef;
  cursor: pointer;
}
.progress-container {
  position: relative;
  height: 7px;
  background-color: rgba(192, 192, 192, 0.41);
  border-radius: 8px;
}
.progress {
  position: absolute;
  height: 7px;
  background-color: white;
  border-radius: 8px;
}


</style>


// WEBPACK FOOTER //
// RatingHistoryCard.vue?8f47ebf6